// Дзеркало Prisma enum AssignmentTeacherRole. Роль викладача в навантаженні.
// Значення ідентичні apps/api/prisma/schema.prisma (перевіряє test/enums.spec.ts). Підписи — лише тут.
export const AssignmentTeacherRole = {
    MAIN: 'MAIN',
    CO: 'CO',
};
/** Значення в порядку оголошення в схемі. */
export const ASSIGNMENT_TEACHER_ROLE_VALUES = ['MAIN', 'CO'];
export const ASSIGNMENT_TEACHER_ROLE_LABELS = {
    MAIN: 'Основний викладач',
    CO: 'Співвикладач',
};
//# sourceMappingURL=assignment-teacher-role.js.map